import { Component, inject, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ListenersRegistry } from '@skylab-shared/utils';
import { DialogInsService } from './dialog-ins.service';

import { ConsoleLogger } from '@skylab-shared/core';
import { DialogButtonResult, DialogState } from './dialog.model';

export interface DialogContentViewModel { }

@Component({
    template: '',
})
export abstract class DialogContentComponentBase<TViewModel extends DialogContentViewModel, TData = unknown, TResultData = unknown> extends ListenersRegistry(class { }) implements OnInit, OnDestroy {
    protected readonly logger: ConsoleLogger;
    @Input() public data!: TData;

    public viewModel: TViewModel;

    private dialogKeyActionSubscription!: Subscription;

    public injector = inject(Injector);

    public constructor(
        protected readonly dialogService: DialogInsService
    ) {
        super();
        this.logger = new ConsoleLogger(this.constructor.name);
    }

    public ngOnInit(): void {
        this.viewModel = this.getInitialState();
        this.prepareAsync();
        this.initEvents();
    }

    private initEvents(): void {
        this.dialogKeyActionSubscription = this.dialogService.keyAction$.subscribe(state => {
            this.onAction({state});
        });
    }

    public ngOnDestroy(): void {
        this.dialogKeyActionSubscription?.unsubscribe();
        this.dispose();
    }

    private async prepareAsync(): Promise<void> {
        try {
            await this.prepareDataAsync();

        } catch (err) {
            this.logger.error(err);
            this.onCancel();
        } finally {
            this.isReady();
            this.onPrepared();
        }
    }

    protected getInitialState(): TViewModel {
        return <TViewModel>{};
    }

    protected async prepareDataAsync(): Promise<void> {}

    protected onPrepared(): void {}

    protected isReady(): void {}

    protected dispose(): void {}

    public onAction(data: DialogButtonResult): void {
        this.dialogService.close(data);
    }

    protected isCanceled: boolean = false;
    public onCancel(): void {
        this.dialogService.close({ state: DialogState.Cancel });
        this.isCanceled = true;
    }
}
